interface Props {
  targetStatus: string | null;
  targetClassification?: string | null;
  targetYear: string | null;
  type: SingleSbtiType;
}

export enum SingleSbtiType {
  NEAR_TERM = 'Near term',
  LONG_TERM = 'Long term',
  NET_ZERO = 'Net zero',
}

export const SingleSbtiTarget = (props: Props) => {
  if (!props.targetStatus) {
    return <></>;
  }
  if (props.type === SingleSbtiType.NET_ZERO) {
    return (
      <p>
        <span>{props.type}: Committed</span> {props.targetYear && <span>by {props.targetYear}</span>}
      </p>
    );
  }
  if (!props.targetClassification) {
    return <p>{props.type}: Committed</p>;
  }
  return (
    <p>
      <span>
        {props.type}: {props.targetClassification}
      </span>{' '}
      {props.targetYear && <span>by {props.targetYear}</span>}
    </p>
  );
};
